import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";

const PopoverContent = ({ content, position, onClose }) => {
  const popoverRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);
  return createPortal(
    <div
      ref={popoverRef}
      style={{
        position: "absolute",
        left: `${position.left}px`,
        top: `${position.top}px`,
        zIndex: 1000,
        backgroundColor: "#333",
        color: "#fff",
        borderRadius: "4px",
        padding: "6px 10px",
        fontSize: "12px",
        whiteSpace: "nowrap",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        transform: "translateX(-50%)",
      }}
    >
      {content}
     <div className="triangle-down" />
    </div>,
    document.body
  );
};

const CommentsAllButton = (props) => {
  const context = props.context.componentParent;
  const indent = props.data.indent || {};

  const [showPopover, setShowPopover] = useState(false);
  const [position, setPosition] = useState({ left: 0, top: 0 });

  const handleClick = (type, e) => {
    e.stopPropagation();
    if (type === "commentsall") {
      context.onClickallcomments(props);
    }
  };

  const hasComments1 = [
    indent.reasonforrejectionbyvendor,
    indent.adminbifurComment,
    indent.rejected_reason_by_approval1,
    indent.rejection_reason_for_superadmin,
  ].some((val) => val && val.trim() !== "");

  const handleMouseEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setPosition({
      left: rect.left + rect.width / 2,
      top: rect.top - 35 + window.scrollY, // tooltip above
    });
    setShowPopover(true);
  };

  const handleMouseLeave = () => {
    setShowPopover(false);
  };

  return (
    <div>
      {indent.is_draft === 1 ? null : (
        <>
          {hasComments1 ? (
            <button
              onClick={(e) => handleClick("commentsall", e)}
              className="custom-btn label label-success"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <i
                className="icofont icofont-history f18"
                style={{ cursor: "pointer" }}
              ></i>
            </button>
          ) : (
            <button
              onClick={(e) => handleClick("commentsall", e)}
              className="custom-btn label label-secondary"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              style={{ cursor: "not-allowed" }}
            >
              <i
                className="icofont icofont-history f18"
                style={{ cursor: "pointer" }}
              ></i>
            </button>
          )}
          {showPopover && (
            <PopoverContent
              content="Logs"
              position={position}
              onClose={() => setShowPopover(false)}
            />
          )}
        </>
      )}
    </div>
  );
};

export default CommentsAllButton;
